import { brand } from '../../../theme/themePrimitives';
import { resetStatesExceptAuth } from '../../../helper/reset_helper';
import { styled } from '@mui/material/styles';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { AppDispatch, RootState } from '../../../redux/store';
import { CurrencyExchangeOutlined, DashboardOutlined, PeopleOutlineOutlined, PersonSearchOutlined, VerifiedUserOutlined } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const StyledToggleButton = styled(ToggleButton)(({ selected }) => ({
    border: 'none !important',
    backgroundColor: selected ? `${brand[300]} !important` : 'transparent',
    color: selected ? 'white !important' : 'black',
    fontSize: '0.9rem !important',
    fontWeight: '600 !important',
    padding: '8px 10px !important',
    borderRadius: '10px !important',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
    // boxShadow: selected ? '1px 1px 1px 1px #ededed' : 'none'
}));

const StyledToggleGroupBox = styled(ToggleButtonGroup)(({ theme }) => ({
    border: theme.palette.mode === 'dark' ? '1px solid rgb(92, 92, 92)' : '1px solid #ededed',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
}));

const NavigationComponent = ({ setSelectedpage, selectedPage }: { setSelectedpage: (value: string) => void, selectedPage: string }) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { isSales } = useSelector((state: RootState) => state.app);

    useEffect(() => {
        // ✅ Set initial alignment based on the URL path
        const path = location.pathname.split('/app/')[1] || 'dashboard';
        setSelectedpage(path);
    }, [location.pathname]);

    /**
         * @heading3: Functions
         * @heading4: Handles alignment state change.
         * @code:
         * handleChange();
         */
    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string | null
    ) => {
        if (!newAlignment || location.pathname.includes(`/app/${newAlignment}`)) {
            return;
        }
        // setAlignment(newAlignment);
        setSelectedpage(newAlignment);
        if (newAlignment) {
            resetStatesExceptAuth(dispatch);
            navigate(`/app/${newAlignment}`);
        }
    };

    if (location.pathname.includes('subscription')) {
        return null;
    }

    return (
        <StyledToggleGroupBox
            color="primary"
            value={selectedPage}
            exclusive
            onChange={handleChange}
            aria-label="Platform navigation"
        >
            {isSales && !location.pathname.includes('subscription') && <StyledToggleButton value="dashboard" selected={location.pathname.includes('dashboard') && !location.pathname.includes('client')}>
                <PeopleOutlineOutlined fontSize="small" /> Client Management
            </StyledToggleButton>}
            {!isSales && !location.pathname.includes('subscription') && <StyledToggleButton value="dashboard" selected={location.pathname.includes('dashboard')}>
                <DashboardOutlined fontSize="small" /> Dashboard
            </StyledToggleButton>}
            {!isSales && !location.pathname.includes('subscription') && <StyledToggleButton value="rolodex" selected={location.pathname.includes('rolodex')}>
                <VerifiedUserOutlined fontSize="small" /> Rolodex
            </StyledToggleButton>}
            {!isSales && !location.pathname.includes('subscription') && <StyledToggleButton value="deals" selected={location.pathname.includes('deals')}>
                <CurrencyExchangeOutlined fontSize="small" />  Deals
            </StyledToggleButton>}
            {!isSales && !location.pathname.includes('subscription') && <StyledToggleButton value="leads" selected={location.pathname.includes('leads')}>
                <PersonSearchOutlined fontSize="small" />  Leads
            </StyledToggleButton>}
        </StyledToggleGroupBox>
    );
};

export default NavigationComponent;